import React from 'react';
import { isMobile } from 'react-device-detect';

import Breadcrumbs from '../Breadcrumbs';
import MobileAsideWrapper from '../MobileAsideWrapper';

import styles from './containersidebar.module.css';

import LearnSideCTA from '@components/LearnSideCTA';

const ContainerSidebar = ({
  children,
  type,
  postTitle,
  asideComponent,
  dbName,
}) => {
  const LEARN_CTA_SIGNUP_URL = `https://popsql.com/users/sign_up?utm_source=inbound&utm_medium=website&utm_campaign=learnsql&utm_content=valprop`;

  const getRandomCTA = (connector = 'MySQL') => {
    const list = [
      {
        id: 1,
        title: `Finally, a unified workspace for your SQL development`,
        description: `Get more done, together, with PopSQL and ${connector}`,
        ctaText: `Get started in minutes`,
      },
      {
        id: 2,
        title: `Real-time SQL collaboration is here`,
        description: `Get started with PopSQL and ${connector} in minutes`,
        ctaText: `Sign up for free`,
      },
      {
        id: 3,
        title: `SQL editing that just rocks`,
        description: `PopSQL and ${connector}, better together`,
        ctaText: `Get started in minutes`,
      },
      {
        id: 4,
        title: `From ${connector} query to chart to Slack in seconds`,
        description: `Get to answers faster, together, with PopSQL and ${connector}`,
        ctaText: `Sign up for free`,
      },
      {
        id: 5,
        title: `Shared queries and folders ✅ Version history  ✅ One-click connection to ${connector}  ✅`,
        description: `Get more done, together, with PopSQL and ${connector}`,
        ctaText: `Get started in minutes`,
      },
      {
        id: 6,
        title: `Better SQL for the people`,
        description: `Get more done with PopSQL and ${connector}`,
        ctaText: `Try now for free`,
      },
    ];
    const random = list[Math.floor(Math.random() * list.length)];

    return random;
  };

  const randomCTA = getRandomCTA(dbName);

  return (
    <section
      className={`px-4 md:mt-12 grid grid-cols-3 sm:gap-10 m-auto ${
        styles.wrapper
      } ${postTitle ? 'max-w-[1400px]' : 'max-w-[1200px]'}`}
    >
      <div className="hidden md:block">{asideComponent}</div>
      <div className="md:hidden">
        <MobileAsideWrapper>{asideComponent}</MobileAsideWrapper>
      </div>
      <section className="min-h-screen">
        {!isMobile && (
          <Breadcrumbs isLearn={type === 'learn'} postTitle={postTitle} />
        )}
        {children}
      </section>

      {dbName && (
        <div className="">
          <LearnSideCTA
            cta={{
              text: randomCTA.ctaText,
              href: LEARN_CTA_SIGNUP_URL,
            }}
            title={randomCTA.title}
            description={randomCTA.description}
            image={`${
              process.env.NEXT_PUBLIC_ASSET_HOST
            }/static/landing/first-section/${dbName
              .split(' ')
              .join('-')
              .toLowerCase()}.svg`}
          />
        </div>
      )}
    </section>
  );
};

export default ContainerSidebar;
